<script>
  export default {
    props: {
      title: {
        type: String,
        default: '洽詢專線'
      },
      type: {
        type: String,
        default: ''
      },
      brandList: {
        type: Array,
        default: () => {
          return [
            {
              "title": "BlcakBerry",
              "alias": "blcakberry",
              "logo": "https://assets.codepen.io/1759070/logo_1.svg",
              "contact": [
                {
                  "name": "王小明",
                  "gender": "先生",
                  "countryCode": "02",
                  "phone": "22221234",
                  "extension": "1111"
                },
                {
                  "name": "林小花",
                  "gender": "先生",
                  "countryCode": "02",
                  "phone": "22225566",
                  "extension": "2222"
                }
              ]
            },
            {
              "title": "VMware",
              "alias": "vmware",
              "logo": "https://assets.codepen.io/1759070/logo_1.svg",
              "contact": []
            }
          ]
        }
      }
    }
  }
</script>

<template>
  <div :class="$style.listContact">
    <h4
      v-if="title"
      class="listContact__title">
      {{ title }}
    </h4>
    <div v-if="type === 'event'" :class="$style.brandList">
      <ul :class="$style.contactList">
        <li
          v-for="(contactList, $index2) in brandList"
          :key="$index2"
          class="contactList__item"
        >
          <div class="d-lg-none mb-2">{{ contactList.name }}{{ contactList.gender }}</div>
          <i class="icomoon icon-call contactList__icon"></i>
          <span class="d-lg-inline d-none">{{ contactList.name }}{{ contactList.gender }}</span> {{ contactList.countryCode }}-{{ contactList.phone }} {{
            contactList.extension
              ? '分機：' + contactList.extension
              : ''
          }}
        </li>
      </ul>
    </div>
    <div v-else :class="$style.brandList">
      <template v-for="(brandItem, index) in brandList">
        <div
          v-if="!!brandItem.contact[0]"
          :key="`brandList-${index}`"
          class="brandList__item">
          <h5 class="brandList__title">{{ brandItem.title }}</h5>
          <ul :class="$style.contactList">
            <li
              v-for="(contactList, $index2) in brandItem.contact"
              :key="$index2"
              class="contactList__item"
            >
              <div class="d-lg-none mb-2">{{ contactList.name }}{{ contactList.gender }}</div>
              <i class="icomoon icon-call contactList__icon"></i>
              <span class="d-lg-inline d-none">{{ contactList.name }}{{ contactList.gender }}</span> {{ contactList.countryCode }}-{{ contactList.phone }} {{
                contactList.extension
                  ? '分機：' + contactList.extension
                  : ''
              }}
            </li>
          </ul>
        </div>
      </template>
    </div>
    <!--<template v-for="(brandItem, index) in brandList">
      <div
        :key="`brandList-${index}`"
        :class="$style.brandList"
      >
        <div
          v-if="!!brandItem.contact[0]"
          class="brandList__item">
          <h5 class="brandList__title">{{ brandItem.title }}</h5>
          <ul :class="$style.contactList">
            <li
              v-for="(contactList, $index2) in brandItem.contact"
              :key="$index2"
              class="contactList__item"
            >
              <i class="icomoon icon-call contactList__icon"></i>
              {{ contactList.name }}{{ contactList.gender }} {{ contactList.countryCode }}-{{ contactList.phone }} {{ contactList.extension ? '分機：' + contactList.extension : '' }}
            </li>
          </ul>
        </div>
      </div>
    </template>-->
  </div>
</template>
<style lang="scss" module>
  .listContact {
    :global {
      .listContact {
        &__title {
          margin-bottom: 1.875rem;
          font-size: 1.25rem;
          color: $color-gray-7;
        }

        &__item {
          margin-bottom: 1.5rem;
          font-size: 1rem;
          color: $color-gray-6;
        }
      }
    }
  }

  .brandList {
    :global {
      .brandList {
        &__item {
          &:not(:last-child) {
            margin-bottom: 1rem;
          }
        }

        &__title {
          margin-bottom: 0.8125rem;
          font-size: 1rem;
          color: $color-gray-6;
        }
      }
    }
  }

  .contactList {
    padding: 0;
    margin: 0;
    list-style: none;

    :global {
      .contactList {
        &__item {
          padding-bottom: 0.8rem;
          font-size: 1rem;
          color: $color-gray-6;
        }

        &__icon {

        }
      }
    }
  }
</style>
